"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

/**
 * Filters out non-DOM props from a field object provided by Redux Form.
 * Required as a workaround for Redux Form v5 due to React's 'unknown props' warning.
 * See https://github.com/erikras/redux-form/issues/1249.
 * @param initialValue
 * @param autofill
 * @param onUpdate
 * @param valid
 * @param invalid
 * @param dirty
 * @param pristine
 * @param active
 * @param touched
 * @param visited
 * @param autofilled
 * @param error
 * @param domProps
 * @returns {Object} Props that are valid for HTML input elements.
 */
exports.default = function (_ref) {
  var initialValue = _ref.initialValue,
      autofill = _ref.autofill,
      onUpdate = _ref.onUpdate,
      valid = _ref.valid,
      invalid = _ref.invalid,
      dirty = _ref.dirty,
      pristine = _ref.pristine,
      active = _ref.active,
      touched = _ref.touched,
      visited = _ref.visited,
      autofilled = _ref.autofilled,
      error = _ref.error,
      domProps = _objectWithoutProperties(_ref, ["initialValue", "autofill", "onUpdate", "valid", "invalid", "dirty", "pristine", "active", "touched", "visited", "autofilled", "error"]);

  return domProps;
};


//////////////////
// WEBPACK FOOTER
// ./src/v2/helpers/reduxFormPropFilter.js
// module id = 414
// module chunks = 0